import { fg } from '@atlaskit/platform-feature-flags';
import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const isLocalStorageAvailable = (): boolean => {
	if (!fg('fix_ssr_browser_storage_undefined')) {
		return true;
	}
	return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};

export const setLocalStorageItem: (key: string, value: string) => void = (
	key: string,
	value: string,
): void => {
	if (!isLocalStorageAvailable()) {
		return;
	}
	if (fg('search_page_use_browser_storage_controls')) {
		AtlBrowserStorageLocal.setItem(key, value);
	} else {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.setItem(key, value);
	}
};

export const getLocalStorageItem: (key: string) => any = (key: string): any => {
	if (!isLocalStorageAvailable()) {
		return null;
	}
	const item = fg('search_page_use_browser_storage_controls')
		? AtlBrowserStorageLocal.getItem(key)
		: // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
			localStorage.getItem(key);
	return item ? JSON.parse(item) : null;
};

export const getLocalStorageItemAsString: (key: string) => string | null = (key: string) => {
	if (!isLocalStorageAvailable()) {
		return null;
	}
	const item = fg('search_page_use_browser_storage_controls')
		? AtlBrowserStorageLocal.getItem(key)
		: // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
			localStorage.getItem(key);
	return item ? item : null;
};

export const removeLocalStorageItem: (key: string) => void = (key: string): void => {
	if (!isLocalStorageAvailable()) {
		return;
	}
	if (fg('search_page_use_browser_storage_controls')) {
		AtlBrowserStorageLocal.removeItem(key);
	} else {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.removeItem(key);
	}
};
